/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-09 08:56:09
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const GET_CAMPAIGN_BANNERS_REQUEST = 'GET_CAMPAIGN_BANNERS_REQUEST';
type GET_CAMPAIGN_BANNERS_REQUEST_TYPE = 'GET_CAMPAIGN_BANNERS_REQUEST';

export const GET_CAMPAIGN_BANNERS_SUCCESS = 'GET_CAMPAIGN_BANNERS_SUCCESS';
type GET_CAMPAIGN_BANNERS_SUCCESS_TYPE = 'GET_CAMPAIGN_BANNERS_SUCCESS';

export const GET_CAMPAIGN_BANNERS_FAILURE = 'GET_CAMPAIGN_BANNERS_FAILURE';
type GET_CAMPAIGN_BANNERS_FAILURE_TYPE = 'GET_CAMPAIGN_BANNERS_FAILURE';

export const GET_DASHBOARD_BLOCKS_REQUEST = 'GET_DASHBOARD_BLOCKS_REQUEST';
type GET_DASHBOARD_BLOCKS_REQUEST_TYPE = 'GET_DASHBOARD_BLOCKS_REQUEST';

export const GET_DASHBOARD_BLOCKS_SUCCESS = 'GET_DASHBOARD_BLOCKS_SUCCESS';
type GET_DASHBOARD_BLOCKS_SUCCESS_TYPE = 'GET_DASHBOARD_BLOCKS_SUCCESS';

export const GET_DASHBOARD_BLOCKS_FAILURE = 'GET_DASHBOARD_BLOCKS_FAILURE';
type GET_DASHBOARD_BLOCKS_FAILURE_TYPE = 'GET_DASHBOARD_BLOCKS_FAILURE';

export const GET_IN_APP_SPOTLIGHT_REQUEST = 'GET_IN_APP_SPOTLIGHT_REQUEST';
type GET_IN_APP_SPOTLIGHT_REQUEST_TYPE = 'GET_IN_APP_SPOTLIGHT_REQUEST';

export const GET_IN_APP_SPOTLIGHT_SUCCESS = 'GET_IN_APP_SPOTLIGHT_SUCCESS';
type GET_IN_APP_SPOTLIGHT_SUCCESS_TYPE = 'GET_IN_APP_SPOTLIGHT_SUCCESS';

export const GET_IN_APP_SPOTLIGHT_FAILURE = 'GET_IN_APP_SPOTLIGHT_FAILURE';
type GET_IN_APP_SPOTLIGHT_FAILURE_TYPE = 'GET_IN_APP_SPOTLIGHT_FAILURE';

export const GET_DASHBOARD_COMPONENTS_REQUEST = 'GET_DASHBOARD_COMPONENTS_REQUEST';
type GET_DASHBOARD_COMPONENTS_REQUEST_TYPE = 'GET_DASHBOARD_COMPONENTS_REQUEST';

export const GET_DASHBOARD_COMPONENTS_SUCCESS = 'GET_DASHBOARD_COMPONENTS_SUCCESS';
type GET_DASHBOARD_COMPONENTS_SUCCESS_TYPE = 'GET_DASHBOARD_COMPONENTS_SUCCESS';

export const GET_DASHBOARD_COMPONENTS_FAILURE = 'GET_DASHBOARD_COMPONENTS_FAILURE';
type GET_DASHBOARD_COMPONENTS_FAILURE_TYPE = 'GET_DASHBOARD_COMPONENTS_FAILURE';

export const GET_CROSS_SELL_UP_SELL_REQUEST = 'GET_CROSS_SELL_UP_SELL_REQUEST';
type GET_CROSS_SELL_UP_SELL_REQUEST_TYPE = 'GET_CROSS_SELL_UP_SELL_REQUEST';

export const GET_CROSS_SELL_UP_SELL_SUCCESS = 'GET_CROSS_SELL_UP_SELL_SUCCESS';
type GET_CROSS_SELL_UP_SELL_SUCCESS_TYPE = 'GET_CROSS_SELL_UP_SELL_SUCCESS';

export const GET_CROSS_SELL_UP_SELL_FAILURE = 'GET_CROSS_SELL_UP_SELL_FAILURE';
type GET_CROSS_SELL_UP_SELL_FAILURE_TYPE = 'GET_CROSS_SELL_UP_SELL_FAILURE';

export const GET_CHANGE_LOGS_REQUEST = 'GET_CHANGE_LOGS_REQUEST';
type GET_CHANGE_LOGS_REQUEST_TYPE = 'GET_CHANGE_LOGS_REQUEST';

export const GET_CHANGE_LOGS_SUCCESS = 'GET_CHANGE_LOGS_SUCCESS';
type GET_CHANGE_LOGS_SUCCESS_TYPE = 'GET_CHANGE_LOGS_SUCCESS';

export const GET_CHANGE_LOGS_FAILURE = 'GET_CHANGE_LOGS_FAILURE';
type GET_CHANGE_LOGS_FAILURE_TYPE = 'GET_CHANGE_LOGS_FAILURE';

export const FEEDBACK_REQUEST = 'FEEDBACK_REQUEST';
type FEEDBACK_REQUEST_TYPE = 'FEEDBACK_REQUEST';

export const FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS';
type FEEDBACK_SUCCESS_TYPE = 'FEEDBACK_SUCCESS';

export const FEEDBACK_FAILURE = 'FEEDBACK_FAILURE';
type FEEDBACK_FAILURE_TYPE = 'FEEDBACK_FAILURE';

export const PROCESS_DISMISS_BLOCK_REQUEST = 'PROCESS_DISMISS_BLOCK_REQUEST';
type PROCESS_DISMISS_BLOCK_REQUEST_TYPE = 'PROCESS_DISMISS_BLOCK_REQUEST';

export const PROCESS_DISMISS_BLOCK_SUCCESS = 'PROCESS_DISMISS_BLOCK_SUCCESS';
type PROCESS_DISMISS_BLOCK_SUCCESS_TYPE = 'PROCESS_DISMISS_BLOCK_SUCCESS';

export const PROCESS_DISMISS_BLOCK_FAILURE = 'PROCESS_DISMISS_BLOCK_FAILURE';
type PROCESS_DISMISS_BLOCK_FAILURE_TYPE = 'PROCESS_DISMISS_BLOCK_FAILURE';

export const CONFIRM_DISMISS_BLOCK = 'CONFIRM_DISMISS_BLOCK';
type CONFIRM_DISMISS_BLOCK_TYPE = 'CONFIRM_DISMISS_BLOCK';

export const UPDATE_DASHBOARD_BLOCK = 'UPDATE_DASHBOARD_BLOCK';
type UPDATE_DASHBOARD_BLOCK_TYPE = 'UPDATE_DASHBOARD_BLOCK';

export const IM_IN_FEEDBACK_5TARS = 'IM_IN_FEEDBACK_5TARS';
type IM_IN_FEEDBACK_5TARS_TYPE = 'IM_IN_FEEDBACK_5TARS';

export const DISABLE_SEARCH_ONBOARDING_REQUEST =
  'DISABLE_SEARCH_ONBOARDING_REQUEST';
type DISABLE_SEARCH_ONBOARDING_REQUEST_TYPE =
  'DISABLE_SEARCH_ONBOARDING_REQUEST';

export const DISABLE_SEARCH_ONBOARDING_SUCCESS =
  'DISABLE_SEARCH_ONBOARDING_SUCCESS';
type DISABLE_SEARCH_ONBOARDING_SUCCESS_TYPE =
  'DISABLE_SEARCH_ONBOARDING_SUCCESS';

export const DISABLE_SEARCH_ONBOARDING_FAILURE =
  'DISABLE_SEARCH_ONBOARDING_FAILURE';
type DISABLE_SEARCH_ONBOARDING_FAILURE_TYPE =
  'DISABLE_SEARCH_ONBOARDING_FAILURE';

export const SET_SHOW_INSTALLATION_STATUS_BANNER_REQUEST =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_REQUEST';
type SET_SHOW_INSTALLATION_STATUS_BANNER_REQUEST_TYPE =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_REQUEST';

export const SET_SHOW_INSTALLATION_STATUS_BANNER_SUCCESS =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_SUCCESS';
type SET_SHOW_INSTALLATION_STATUS_BANNER_SUCCESS_TYPE =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_SUCCESS';

export const SET_SHOW_INSTALLATION_STATUS_BANNER_FAILURE =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_FAILURE';
type SET_SHOW_INSTALLATION_STATUS_BANNER_FAILURE_TYPE =
  'SET_SHOW_INSTALLATION_STATUS_BANNER_FAILURE';

type GetDashboardBlocksSuccess = {
  data: Object
};

type GetDashboardComponentsSuccess = {
  data: Object
};

type SetShowInstallationStatusBannerSuccess = {
  data: Object
};

type DashBoardFaiLure = {
  error: any
};

type DashBoardBlockFailure = DashBoardFaiLure & {
  blockName: string
};

type DismissBlockSuccess = {
  data: Object,
  blockName: string
};

// GET DASHBOARD BLOCKS
type GetDashboardBlocksRequestAction = Action<GET_DASHBOARD_BLOCKS_REQUEST_TYPE, null>;

type GetDashboardBlocksSuccessAction = Action<
  GET_DASHBOARD_BLOCKS_SUCCESS_TYPE,
  GetDashboardBlocksSuccess
>;

type GetDashboardBlocksFailureAction = Action<GET_DASHBOARD_BLOCKS_FAILURE_TYPE, DashBoardFaiLure>;

// Get campaign banners
type GetCampaignBannersRequestAction = Action<GET_CAMPAIGN_BANNERS_REQUEST_TYPE, null>;

type GetCampaignBannersSuccessAction = Action<GET_CAMPAIGN_BANNERS_SUCCESS_TYPE, { data: Object }>;

type GetCampaignBannersFailureAction = Action<GET_CAMPAIGN_BANNERS_FAILURE_TYPE, DashBoardFaiLure>;

// Get in app spotlight
type GetInAppSpotlightRequestAction = Action<GET_IN_APP_SPOTLIGHT_REQUEST_TYPE, null>;

type GetInAppSpotlightSuccessAction = Action<GET_IN_APP_SPOTLIGHT_SUCCESS_TYPE, { data: Object }>;

type GetInAppSpotlightFailureAction = Action<GET_IN_APP_SPOTLIGHT_FAILURE_TYPE, DashBoardFaiLure>;
// GET DASHBOARD COMPONENTS
type GetDashboardComponentsRequestAction = Action<GET_DASHBOARD_COMPONENTS_REQUEST_TYPE, null>;

type GetDashboardComponentsSuccessAction = Action<
  GET_DASHBOARD_COMPONENTS_SUCCESS_TYPE,
  GetDashboardComponentsSuccess
>;

type GetDashboardComponentsFailureAction = Action<
  GET_DASHBOARD_COMPONENTS_FAILURE_TYPE,
  DashBoardFaiLure
>;
// GET CHANGE LOGS
type GetChangelogsRequestAction = Action<GET_CHANGE_LOGS_REQUEST_TYPE, null>;

type GetChangelogsSuccessAction = Action<
  GET_CHANGE_LOGS_SUCCESS_TYPE,
  GetDashboardComponentsSuccess
>;

type GetChangelogsFailureAction = Action<GET_CHANGE_LOGS_FAILURE_TYPE, DashBoardFaiLure>;
// GET FEATURES LIST
type GetCrossSellUpSellRequestAction = Action<GET_CROSS_SELL_UP_SELL_REQUEST_TYPE, null>;

type GetCrossSellUpSellSuccessAction = Action<
  GET_CROSS_SELL_UP_SELL_SUCCESS_TYPE,
  GetDashboardComponentsSuccess
>;

type GetCrossSellUpSellFailureAction = Action<
  GET_CROSS_SELL_UP_SELL_FAILURE_TYPE,
  DashBoardFaiLure
>;
//PROCESS FEEDBACK
type FeedBackRequestAction = Action<FEEDBACK_REQUEST_TYPE, { blockName: string }>;

type FeedBackSuccessAction = Action<FEEDBACK_SUCCESS_TYPE, { message: string, blockName: string }>;

type FeedBackFailureAction = Action<FEEDBACK_FAILURE_TYPE, DashBoardBlockFailure>;

// Search onboarding
type DisableSearchOnboardingRequestAction = Action<
  DISABLE_SEARCH_ONBOARDING_REQUEST_TYPE,
  null
>;

type DisableSearchOnboardingSuccessAction = Action<
  DISABLE_SEARCH_ONBOARDING_SUCCESS_TYPE,
  null
>;

type DisableSearchOnboardingFailureAction = Action<
  DISABLE_SEARCH_ONBOARDING_FAILURE_TYPE,
  DashBoardFaiLure
>;

// SET SHOW INSTALLATION SUCCESS BANNER
type SetShowInstallationStatusBannerRequestAction = Action<
  SET_SHOW_INSTALLATION_STATUS_BANNER_REQUEST_TYPE,
  null
>;

type SetShowInstallationStatusBannerSuccessAction = Action<
  SET_SHOW_INSTALLATION_STATUS_BANNER_SUCCESS_TYPE,
  SetShowInstallationStatusBannerSuccess
>;

type SetShowInstallationStatusBannerFailureAction = Action<
  SET_SHOW_INSTALLATION_STATUS_BANNER_FAILURE_TYPE,
  DashBoardFaiLure
>;

type ProcessDismissBlockRequestAction = Action<
  PROCESS_DISMISS_BLOCK_REQUEST_TYPE,
  { blockName: string }
>;

type ProcessDismissBlockSuccessAction = Action<
  PROCESS_DISMISS_BLOCK_SUCCESS_TYPE,
  DismissBlockSuccess
>;

type ProcessDismissBlockFailureAction = Action<
  PROCESS_DISMISS_BLOCK_FAILURE_TYPE,
  DashBoardBlockFailure
>;

type ConfirmDismissBlockAction = Action<CONFIRM_DISMISS_BLOCK_TYPE, { blockName: string }>;

type UpdateDashboardBlockAction = Action<UPDATE_DASHBOARD_BLOCK_TYPE, { blocks: Object }>;

type ImInFeedback5StarsAction = Action<IM_IN_FEEDBACK_5TARS_TYPE, { blocks: Object }>;

export type DashboardAction =
  | GetDashboardBlocksRequestAction
  | GetDashboardBlocksSuccessAction
  | GetDashboardBlocksFailureAction
  | GetCampaignBannersRequestAction
  | GetCampaignBannersSuccessAction
  | GetCampaignBannersFailureAction
  | GetInAppSpotlightRequestAction
  | GetInAppSpotlightSuccessAction
  | GetInAppSpotlightFailureAction
  | GetDashboardComponentsRequestAction
  | GetDashboardComponentsSuccessAction
  | GetDashboardComponentsFailureAction
  | GetChangelogsRequestAction
  | GetChangelogsSuccessAction
  | GetChangelogsFailureAction
  | GetCrossSellUpSellRequestAction
  | GetCrossSellUpSellSuccessAction
  | GetCrossSellUpSellFailureAction
  | FeedBackRequestAction
  | FeedBackSuccessAction
  | FeedBackFailureAction
  | ProcessDismissBlockRequestAction
  | ProcessDismissBlockSuccessAction
  | ProcessDismissBlockFailureAction
  | ConfirmDismissBlockAction
  | UpdateDashboardBlockAction
  | SetShowInstallationStatusBannerRequestAction
  | SetShowInstallationStatusBannerSuccessAction
  | SetShowInstallationStatusBannerFailureAction
  | ImInFeedback5StarsAction
  | DisableSearchOnboardingRequestAction
  | DisableSearchOnboardingSuccessAction
  | DisableSearchOnboardingFailureAction;

export type DashboardState = {
  loading: boolean,
  success: boolean,
  dashboardComponentsLoading: boolean,
  dashboardComponentsSuccess: boolean,
  feedbackLoading: Array<string>,
  feedbackSuccess: Array<string>,
  dismissLoading: Array<string>,
  dismissSuccess: Array<string>,
  error: any,
  dashboardBlocks: Object,
  dashboardComponents: Object
};
